export default __webpack_public_path__ + "static/table-sartoise-0ec0de01c6f15740b73d11725e940e69.jpg";